// src/components/strumenti/GiorniLavorativi.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

function pad2(n){ return String(n).padStart(2,"0"); }
function calcolaPasqua(anno){
  const a=anno%19,b=Math.floor(anno/100),c=anno%100;
  const d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25);
  const g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30;
  const i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7;
  const m=Math.floor((a+11*h+22*l)/451);
  const mese=Math.floor((h+l-7*m+114)/31),giorno=((h+l-7*m+114)%31)+1;
  return new Date(anno,mese-1,giorno);
}
function festivitaItaliane(anno){
  const pasqua=calcolaPasqua(anno);
  const pasquetta=new Date(pasqua); pasquetta.setDate(pasqua.getDate()+1);
  const fmt=d=>`${d.getFullYear()}-${pad2(d.getMonth()+1)}-${pad2(d.getDate())}`;
  return new Set([
    `${anno}-01-01`,`${anno}-01-06`,fmt(pasqua),fmt(pasquetta),
    `${anno}-04-25`,`${anno}-05-01`,`${anno}-06-02`,`${anno}-08-15`,
    `${anno}-11-01`,`${anno}-12-08`,`${anno}-12-25`,`${anno}-12-26`,
    // 4 ottobre, San Francesco d'Assisi: festa nazionale dal 2026 (L. 151/2025)
    ...(anno >= 2026 ? [`${anno}-10-04`] : []),
  ]);
}

export default function GiorniLavorativi() {
  const [dataInizio, setDataInizio] = useState("");
  const [dataFine, setDataFine] = useState("");

  let risultato = null;
  if (dataInizio && dataFine) {
    const d1 = new Date(dataInizio+"T00:00:00");
    const d2 = new Date(dataFine+"T00:00:00");
    if (d2>=d1) {
      let giorniTotali=0, giorniLavorativi=0;
      const anniCoinvolti = new Set();
      for (let d=new Date(d1); d<=d2; d.setDate(d.getDate()+1)) anniCoinvolti.add(d.getFullYear());
      const festivi = new Set();
      anniCoinvolti.forEach(a => festivitaItaliane(a).forEach(f=>festivi.add(f)));
      for (let d=new Date(d1); d<=d2; d.setDate(d.getDate()+1)) {
        giorniTotali++;
        const ds = `${d.getFullYear()}-${pad2(d.getMonth()+1)}-${pad2(d.getDate())}`;
        const isWeekend = d.getDay()===0 || d.getDay()===6;
        if (!isWeekend && !festivi.has(ds)) giorniLavorativi++;
      }
      risultato = { giorniTotali, giorniLavorativi };
    }
  }

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>Data inizio</label>
          <input type="date" value={dataInizio} onChange={e=>setDataInizio(e.target.value)} style={inp}/>
        </div>
        <div>
          <label style={lbl}>Data fine</label>
          <input type="date" value={dataFine} onChange={e=>setDataFine(e.target.value)} style={inp}/>
        </div>
      </div>

      <div style={{ background:"#ecfdf5", border:"1px solid #a7f3d0", borderRadius:10, padding:"14px 16px" }}>
        <div style={{ display:"flex", justifyContent:"space-around" }}>
          <div style={{textAlign:"center"}}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>Giorni totali</div>
            <div style={{ fontSize:20, fontWeight:700, color:"#374151" }}>{risultato ? risultato.giorniTotali : "—"}</div>
          </div>
          <div style={{textAlign:"center"}}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>Giorni lavorativi</div>
            <div style={{ fontSize:24, fontWeight:800, color:"#059669" }}>{risultato ? risultato.giorniLavorativi : "—"}</div>
          </div>
        </div>
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Esclude automaticamente sabato, domenica e le festività nazionali italiane (dal 2026 anche il 4 ottobre, L. 151/2025) (date incluse in entrambi gli estremi).
      </div>

      <button onClick={()=>{setDataInizio("");setDataFine("");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
